import { gql } from "@apollo/client";

export const ODOO_MARGIN_BASE_ON_INVOICES = gql`
  query ODOO_MARGIN_BASE_ON_INVOICES(
    $startDate: String!
    $endDate: String!
    $excludePartnerIds: [Int]
  ) {
    odooMarginBaseOnInvoices(
      startDate: $startDate
      endDate: $endDate
      excludePartnerIds: $excludePartnerIds
    )
  }
`;
